


















































































import Vue from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import { SortOption } from '~/models/dealer/map/types'
import { Dealer } from '~/models/dealer/types'
import { debounce } from '~/utils/function'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import { Option } from '~/models/shared/types'
import { SET_PARAM } from '~/store/modules/shared/dealers/map/mutation-types'
import { DEALERS_MAP_NS } from '~/store/modules/shared/dealers/map/state'
import { faStar as fabStar } from '@fortawesome/free-regular-svg-icons/faStar'
import {
  faRoad,
  faSortAlphaDown,
  faSortAmountDown
} from '@fortawesome/free-solid-svg-icons'
import DealersListItemShimmer from '~/components/car/dealers/map/list/shimmers/DealersListItemShimmer.vue'
import ListItem from '~/components/car/dealers/map/list/item/ListItem.vue'
import NoItems from '~/components/car/dealers/map/list/NoItems.vue'
import { toCamelCase } from '~/utils/object'

export default Vue.extend({
  components: {
    DealersListItemShimmer,
    CCustomSelect,
    ListItem,
    NoItems
  },
  data: () => ({
    facets: {
      sort: {
        value: null
      }
    }
  }),
  computed: {
    ...mapState(DEALERS_MAP_NS, {
      rows: (state): Dealer[] => toCamelCase(state.rows),
      loading: (state): boolean => state.loading,
      totalDealers: (state): number => state.totalDealers,
      sortOptions: (state): SortOption[] => state.sortOptions,
      hasReachedLastPage: (state): boolean => state.hasReachedLastPage,
      geolocation: state => state.params.geolocation
    }),
    sortOptionsOptions(): Option[] {
      return this.sortOptions.map(sortOption => {
        return {
          text: sortOption.name,
          value: sortOption.value
        }
      })
    },
    sort: {
      get() {
        const selectedSortOption = this.sortOptions.find(
          option => option.selected
        )
        return selectedSortOption && selectedSortOption.value
      },
      set(newSort) {
        if (newSort !== this.sort) {
          this.setParam({ name: 'sort', value: newSort })
          this.search()
        }
      }
    }
  },
  watch: {
    geolocation() {
      const dealersRowsRef = this.$refs.dealersRows
      if (dealersRowsRef) {
        dealersRowsRef.scrollTop = 0
      }
    }
  },

  methods: {
    infiniteScrollerVisibilityChanged(isVisible: boolean) {
      if (isVisible) {
        this.pageChanged()
      }
    },
    ...mapActions(DEALERS_MAP_NS, {
      changePage: 'changePage',
      search: 'search'
    }),
    ...mapMutations(DEALERS_MAP_NS, {
      setParam: SET_PARAM
    }),
    getIconBySortValue(value: string) {
      switch (value) {
        case 'google_rating': {
          return {
            isFaIcon: true,
            icon: fabStar
          }
        }
        case 'name': {
          return {
            isFaIcon: true,
            icon: faSortAlphaDown
          }
        }
        case 'classifieds': {
          return {
            isFaIcon: true,
            icon: faSortAmountDown
          }
        }
        case 'postcode': {
          return {
            isFaIcon: true,
            icon: faRoad
          }
        }
      }
    },
    pageChanged: debounce(function() {
      this.changePage()
    }, 50)
  }
})
